module.exports = __webpack_public_path__ + "static/media/ic_视频库.bdcda3ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_视频库.svg
// module id = 406
// module chunks = 0